import { Component } from '@angular/core';

@Component({
    selector: 'lib-compass-add',
    imports: [],
    templateUrl: './compass-add.component.html',
    styleUrl: './compass-add.component.scss'
})
export class CompassAddComponent {

}
